import { defineStore } from 'pinia'

type MessageType = 'success' | 'warning' | 'error' | 'info'

type Message = {
    type: MessageType,
    message: string,
    details?: string,
}

export const useNotificationStore = defineStore('NotificationStore', {
    state: () => ({
        messages: [] as Message[],
        pendingMessages: [] as Message[],
    }),

    actions: {
        clear() {
            this.messages = []
        },

        prepareForPageLoad() {
            this.messages = this.pendingMessages
            this.pendingMessages = []

            if (this.messages.length > 0) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                })
            }
        },

        persistForNextRoute() {
            this.pendingMessages = this.messages
        },

        add(type: MessageType, message: string, details?: string) {
            this.messages.push({
                type,
                message,
                details,
            })

            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            })
        },

        addPending(type: MessageType, message: string, details?: string) {
            this.pendingMessages.push({
                type,
                message,
                details,
            })
        }
    }
})
